<!-- <div class="container">
  <h3 class="fs-30 fw700 py-4">Frequently asked questions</h3>
  <div class="mw640">
    <mat-accordion class="example-headers-align accordionTyp3" multi>
      <ng-container *ngFor="let faq of list; let i= index">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="elink text-capitalize">{{faq.title | titlecase}}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="fs-17" markdown [data]="faq.description"></div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
</div> -->


<div class="container">
  <h3 class="fs-30 fw700 py-4">Frequently asked questions</h3>
  <div class="mw640">
    <mat-accordion class="example-headers-align accordionTyp3" multi>
      <ng-container *ngFor="let faq of jsonArray; let i = index">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="elink text-capitalize">{{faq.title | titlecase}}</mat-panel-title>
          </mat-expansion-panel-header>
          <div *ngFor="let section of faq.sections">
            <div class="fs-17 fw700" style="margin-bottom:15px !important;     font-family: 'Simples Bold';">{{section.subheading}}</div>
            <div class="fs-17" markdown [data]="section.content"></div>
            <!-- <div class="fs-17" style="margin-bottom:15px !important">{{section.content}}</div> -->

          </div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
</div>
